import { render, staticRenderFns } from "./WebCrawlProduct.vue?vue&type=template&id=024b0813&scoped=true"
import script from "./WebCrawlProduct.vue?vue&type=script&lang=js"
export * from "./WebCrawlProduct.vue?vue&type=script&lang=js"
import style0 from "./WebCrawlProduct.vue?vue&type=style&index=0&id=024b0813&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024b0813",
  null
  
)

export default component.exports